/**
 * Frontend mirror of the L2 backend models for part photo +
 * documents. Same shape pattern as `features/vessel-storage` —
 * the L2 spec calls for a copy rather than a generic abstraction
 * (defer EntityPhotoCard<T> to a polish lot).
 */

export const PART_DOCUMENT_KINDS = [
  'DATASHEET',
  'TECHNICAL_DRAWING',
  'MSDS',
  'CERTIFICATE',
  'MANUAL',
  'OTHER',
] as const;
export type PartDocumentKind = (typeof PART_DOCUMENT_KINDS)[number];

export interface PartDocument {
  id: string;
  partId: string;
  kind: PartDocumentKind;
  fileKey: string;
  fileName: string;
  contentType: string;
  /** Backend serialises BigInt → number. Capped at 25 MB by the upload guard. */
  sizeBytes: number;
  uploadedByUserId: string;
  uploadedAt: string;
  deletedAt: string | null;
}

export interface PresignedUpload {
  url: string;
  fileKey: string;
  expiresIn: number;
}

export interface PartPhotoUrl {
  url: string;
  expiresIn: number;
}

export interface PartDocumentDownloadUrl {
  url: string;
  expiresIn: number;
  fileName: string;
}

/** Per-file caps mirrored client-side for instant feedback. Match
 *  the backend `PartsStorageService` constants. */
export const PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const DOC_MAX_BYTES = 25 * 1024 * 1024;
export const PART_QUOTA_BYTES = 100 * 1024 * 1024;

export const ALLOWED_PHOTO_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;
export const ALLOWED_DOC_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
] as const;
